export default __webpack_public_path__ + "static/media/logo_instagram_white.6d9fd197.svg";